import React from 'react';
import {
  ExpoImage,
  Icon,
  LoadingIndicator,
  PinInput,
  ScreenContainer,
  Touchable,
  withTheme,
} from '@draftbit/ui';
import { Text, View } from 'react-native';
import * as GlobalStyles from '../GlobalStyles.js';
import * as LeadFunlDefaultApi from '../apis/LeadFunlDefaultApi.js';
import * as GlobalVariables from '../config/GlobalVariableContext';
import Images from '../config/Images';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import useWindowDimensions from '../utils/useWindowDimensions';

const defaultProps = { email: null };

const OTPScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();
  const [errorMessage, setErrorMessage] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [isResending, setIsResending] = React.useState(false);
  const [pinInputValue, setPinInputValue] = React.useState('');
  const [textInputValue, setTextInputValue] = React.useState('');
  const [codeInputValue, setCodeInputValue] = React.useState(undefined);
  const leadFunlDefaultForgetPasswordInitiatePOST =
    LeadFunlDefaultApi.useForgetPasswordInitiatePOST();

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      hasTopSafeArea={true}
    >
      {/* Header */}
      <View
        style={StyleSheet.applyWidth(
          {
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'space-between',
          },
          dimensions.width
        )}
      >
        {/* Back */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: 'center',
              height: 48,
              justifyContent: 'center',
              width: 48,
            },
            dimensions.width
          )}
        >
          <Touchable
            onPress={() => {
              try {
                navigation.goBack();
              } catch (err) {
                console.error(err);
              }
            }}
          >
            <Icon size={24} name={'AntDesign/arrowleft'} />
          </Touchable>
        </View>
        {/* Screen Heading */}
        <Text
          accessible={true}
          selectable={false}
          style={StyleSheet.applyWidth(
            {
              color: theme.colors.text.strong,
              fontFamily: 'Poppins_400Regular',
              fontSize: 15,
            },
            dimensions.width
          )}
        >
          {'  '}
        </Text>
        {/* Blank */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: 'center',
              height: 48,
              justifyContent: 'center',
              width: 48,
            },
            dimensions.width
          )}
        />
      </View>
      {/* container */}
      <View
        style={StyleSheet.applyWidth(
          {
            alignItems: { minWidth: Breakpoints.Tablet, value: 'center' },
            flex: { minWidth: Breakpoints.Tablet, value: 1 },
            flexDirection: { minWidth: Breakpoints.Tablet, value: 'row' },
            justifyContent: { minWidth: Breakpoints.Tablet, value: 'center' },
          },
          dimensions.width
        )}
      >
        {/* Details View */}
        <>
          {!(dimensions.width >= Breakpoints.Tablet) ? null : (
            <View
              style={StyleSheet.applyWidth(
                {
                  alignItems: { minWidth: Breakpoints.Tablet, value: 'center' },
                  flex: 1,
                  justifyContent: {
                    minWidth: Breakpoints.Tablet,
                    value: 'center',
                  },
                },
                dimensions.width
              )}
            >
              <ExpoImage
                allowDownscaling={true}
                cachePolicy={'disk'}
                contentPosition={'center'}
                transitionDuration={300}
                transitionEffect={'cross-dissolve'}
                transitionTiming={'ease-in-out'}
                {...GlobalStyles.ExpoImageStyles(theme)['Image 2'].props}
                resizeMode={'contain'}
                source={imageSource(Images['_659caa814a5d2ddd2cdc17d8'])}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.ExpoImageStyles(theme)['Image 2'].style,
                    {
                      height: { minWidth: Breakpoints.Tablet, value: 300 },
                      width: { minWidth: Breakpoints.Tablet, value: '70%' },
                    }
                  ),
                  dimensions.width
                )}
              />
            </View>
          )}
        </>
        <View
          style={StyleSheet.applyWidth(
            {
              flex: { minWidth: Breakpoints.Tablet, value: 1 },
              justifyContent: 'space-evenly',
              paddingLeft: 30,
              paddingRight: 30,
              paddingTop: 20,
            },
            dimensions.width
          )}
        >
          {/* Heading */}
          <Text
            accessible={true}
            selectable={false}
            style={StyleSheet.applyWidth(
              {
                color: theme.colors.branding.primary,
                fontFamily: 'Poppins_700Bold',
                fontSize: 35,
                marginBottom: 10,
                textAlign: 'center',
              },
              dimensions.width
            )}
          >
            {'Please enter\nOTP'}
          </Text>
          <PinInput
            autoComplete={'one-time-code'}
            blurOnFull={true}
            cellCount={4}
            changeTextDelay={500}
            clearOnCellFocus={true}
            focusedBorderColor={theme.colors.branding.primary}
            keyboardType={'number-pad'}
            onChangeText={newPinInputValue => {
              const codeInputValue = newPinInputValue;
              try {
                setPinInputValue(newPinInputValue);
              } catch (err) {
                console.error(err);
              }
            }}
            onInputFull={finalValue => {
              const handler = async () => {
                const codeInputValue = finalValue;
                try {
                  setIsLoading(true);
                  const api_Response = (
                    await LeadFunlDefaultApi.forgetPasswordVerifyOTPGET(
                      Constants,
                      {
                        email: props.route?.params?.email ?? defaultProps.email,
                        otp: finalValue,
                      }
                    )
                  )?.json;
                  setIsLoading(false);
                  if (api_Response?.authToken) {
                    setGlobalVariableValue({
                      key: 'TEMP_AUTH_TOKEN',
                      value: api_Response?.authToken,
                    });
                    navigation.navigate('ResetPasswordScreen');
                  } else {
                    setErrorMessage(api_Response?.message);
                  }
                } catch (err) {
                  console.error(err);
                }
              };
              handler();
            }}
            renderItem={({ cellValue, isFocused }) => {
              return null;
            }}
            secureTextEntry={false}
            {...GlobalStyles.PinInputStyles(theme)['Pin Input'].props}
            style={StyleSheet.applyWidth(
              StyleSheet.compose(
                GlobalStyles.PinInputStyles(theme)['Pin Input'].style,
                theme.typography.headline5,
                {}
              ),
              dimensions.width
            )}
            value={pinInputValue}
          />
          <View>
            {/* Resend OTP */}
            <Touchable
              onPress={() => {
                const handler = async () => {
                  try {
                    setIsResending(true);
                    (
                      await leadFunlDefaultForgetPasswordInitiatePOST.mutateAsync(
                        {
                          email:
                            props.route?.params?.email ?? defaultProps.email,
                        }
                      )
                    )?.json;
                    setIsResending(false);
                  } catch (err) {
                    console.error(err);
                  }
                };
                handler();
              }}
              disabled={isLoading || isResending}
              style={StyleSheet.applyWidth({ marginTop: 25 }, dimensions.width)}
            >
              <View
                style={StyleSheet.applyWidth(
                  {
                    alignItems: {
                      minWidth: Breakpoints.Tablet,
                      value: 'center',
                    },
                    flexDirection: {
                      minWidth: Breakpoints.Tablet,
                      value: 'row',
                    },
                    gap: { minWidth: Breakpoints.Tablet, value: 6 },
                    justifyContent: {
                      minWidth: Breakpoints.Tablet,
                      value: 'center',
                    },
                  },
                  dimensions.width
                )}
              >
                <>
                  {!isResending ? null : (
                    <LoadingIndicator
                      color={theme.colors.branding.primary}
                      size={30}
                      type={'circleFade'}
                      size={StyleSheet.getWidthValue(
                        [{ minWidth: Breakpoints.Tablet, value: 20 }],
                        dimensions.width
                      )}
                    />
                  )}
                </>
                {/* Resend OTP */}
                <Text
                  accessible={true}
                  selectable={false}
                  style={StyleSheet.applyWidth(
                    {
                      color: palettes.App['Custom Color'],
                      fontFamily: 'Poppins_400Regular',
                      fontSize: 15,
                      opacity: 0.7,
                      paddingBottom: 6,
                      paddingTop: 6,
                      textAlign: 'center',
                      textDecorationLine: 'underline',
                    },
                    dimensions.width
                  )}
                >
                  {'Resend OTP'}
                </Text>
              </View>
            </Touchable>
          </View>
          {/* View 2 */}
          <View>
            <Text
              accessible={true}
              selectable={false}
              {...GlobalStyles.TextStyles(theme)['Text'].props}
              style={StyleSheet.applyWidth(
                StyleSheet.compose(
                  GlobalStyles.TextStyles(theme)['Text'].style,
                  theme.typography.body1,
                  { color: palettes.Brand.Error, textAlign: 'center' }
                ),
                dimensions.width
              )}
            >
              {errorMessage}
            </Text>
          </View>
        </View>
      </View>
    </ScreenContainer>
  );
};

export default withTheme(OTPScreen);
